import React, { Fragment, useState } from 'react'
import { Combobox, Transition } from '@headlessui/react'
import propTypes from 'prop-types'
import { CloseRoundedIcon, ProfilePicIcon, SearchIcon } from '../../../theme/icons'
import { Button } from '..'

function getRandomRGBColor() {
    const colorArrays = [
        "border-orange-400",
        "border-salmon-400",
        "border-teal-400",
        "border-orange-400",

    ]
    const randomIndex = Math.floor(Math.random() * colorArrays.length);
    return colorArrays[randomIndex];
}

export const UserSearch = React.memo(({ options, onChangeCustomerName, handleTextChange, loader, placeholderText, label, isPopup }) => {
    const [selected, setSelected] = useState({})
    const [query, setQuery] = useState('');
    const [isOpenClose, setOpenClose] = useState(false)

    const filteredList = query === ''
        ? options
        : options.filter((option) =>
            option.value
                .toLowerCase()
                .replace(/\s+/g, '')
                .includes(query?.toLowerCase().replace(/\s+/g, ''))
        )

    const handleClearText = (e) => {
        handleTextChange(e)
        setOpenClose(false);
        setSelected({})
    }

    const handleOnchange = (event) => {
        handleTextChange(event);
        setOpenClose(Boolean(event.target.value));
    }

    React.useEffect(() => {
        if (selected) {
            onChangeCustomerName(selected)
            Object.keys(selected)?.length && setOpenClose(true);
        }
        // eslint-disable-next-line 
    }, [selected])



    return (
        <div >
            {label && <label htmlFor="Customer name or GOAL id" className="mb-1.5 block text-sm font-semibold text-secondary-400">{label}<span className="text-error-400">*</span></label>}
            <Combobox value={selected} onChange={setSelected}>
                <div className="relative py-5">
                    <div className="max-w-260 px-2 py-1.5 ml-auto delay-200 relative border bg-white border-secondary-300 focus-within:border-primary-400 rounded-3xl transition-all duration-300">
                        <div className="flex">
                            <div className="mr-3">
                                <ProfilePicIcon />
                            </div>
                            <Combobox.Input
                                className="w-full border-0 mr-2 p-0 delay-200 block bg-transparent outline-none focus-visible:border-transparent focus:border-transparent focus:ring-transparent sm:text-sm text-xs pr-6"
                                placeholder={loader ? "Fetching Users..." : placeholderText}
                                disabled={loader}
                                displayValue={(person) => loader ? "fetching..." : person.value}
                                onChange={(event) => handleOnchange(event)} />
                            <div className="absolute inset-y-0 right-2.5 flex items-center" role="button">
                                {isOpenClose ?
                                    <Button
                                        onClick={handleClearText}
                                        variant="secondary"
                                        className="flex items-center justify-end p-0 gap-0 mr-0 bg-transparent border-0"
                                        icon={<CloseRoundedIcon />} text=" " /> :
                                    <SearchIcon
                                        aria-hidden="true" />}
                            </div>
                        </div>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        afterLeave={() => setQuery('')}>
                        <Combobox.Options className={`z-50 absolute mt-2 right-0 max-h-60 w-full max-w-260 overflow-auto rounded-4 bg-white py-1 text-base ring-1 ring-secondary-200`}>
                            {loader ?
                                <div className="relative cursor-default select-none py-2.5 px-4 text-gray-700">
                                   fetching...
                                </div> :
                                filteredList.length === 0 ? (
                                    <div className="relative cursor-default select-none py-2.5 px-4 text-gray-700">
                                     No Results found
                                    </div>
                                ) : (
                                    filteredList?.map((option) => (
                                        <Combobox.Option
                                            key={option?._id}
                                            className={({ active }) =>
                                                `relative cursor-pointer select-none py-2 px-4 ${active ? '' : 'text-gray-900'
                                                }`
                                            } value={option}>
                                            {({ selected, active }) => (
                                                <>
                                                    <div className="flex items-center justify-start">
                                                        <div className={`rounded-full flex !w-7 !h-7 text-xs items-center justify-center border ${getRandomRGBColor()} mr-2.5`}>
                                                            <div>{option.value?.split(' ')?.slice(0, 2)?.map(word => word.charAt(0))?.join('')}</div>
                                                        </div>
                                                        <div className="max-w-[180px]">
                                                            <div className={`block truncate ${selected ? 'text-xs' : 'text-xs'}`}>
                                                                {option.value}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </Combobox.Option>
                                    ))
                                )}
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
        </div>
    )
})

UserSearch.propTypes = {
    options: propTypes.array,
    onChangeCustomerName: propTypes.func,
    handleTextChange: propTypes.func,
    loader: propTypes.bool,
    placeholderText: propTypes.string,
    isPopup: propTypes.bool,
}

UserSearch.defaultProps = {
    options: [],
    onChangeCustomerName: () => { },
    handleTextChange: () => { },
    loader: false,
    placeholderText: "Search Teams",
    isPopup: false
}